






















import Vue from 'vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import moment from 'moment'

interface ReplacementRow {
  isChecked: boolean
  Adressverantwortliche: string | null
  Bis: string | null
  Dauer: string
  EinsatzAm: string
  Notiz: string | null
  ProjektSichtDetailId: number
  STVID: number
  Stellvertretung: string | null
  StellvertretungID: number
  Von: string | null
  Wochentag: string | null
  VonBis: string
}

interface ComponentData {
  menu: boolean
  dateRules: any[]
}

export default Vue.extend({
  name: 'DatePickerCell',

  components: {},

  props: {
    rowData: Object as () => ReplacementRow
  },

  data (): ComponentData {
    return {
      menu: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || 'Falsche Datum.' : true
        },

        (value: string) => {
          return value.length !== 10 ? 'Falsche Datum.' : true
        }
      ],
    }
  },

  watch: {},

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getFormattedDate (): string {
      return moment(this.rowData.EinsatzAm).format('DD.MM.YYYY')
    }
  },


  methods: {
    onDateChange (date: string): void {
    this.rowData.Wochentag = moment(date).locale(this.selectedLocale).format("dddd")

    },
  },

  mounted () {}
})

